import * as React from 'react';


export interface SideMenuItem {
  text: string;
  isActive: Boolean;
  onClick: (e: any) => any;
};


const SideMenuItemComponent = ({text, isActive, onClick}) => {
  return (
    <a href="javascript:void(null)" className={'side__sub__nav__anch' + (isActive ? ' active': '')} onClick={onClick}>
      <span className="side__sub__nav__anch__text">{text}</span>
    </a>
  );
};


// TODO: User section
export default ({items}: {items: SideMenuItem[]}) => {
  return (
    <div className="side__sub">
      <h3 className="side__sub__title">Settings</h3>

      <div className="side__sub__nav">
        {items.map((item) => (
          <SideMenuItemComponent
            key={item.text}
            text={item.text}
            isActive={item.isActive}
            onClick={item.onClick}
          />
        ))}
      </div>
    </div>
  );
};
